import { Grid, Switch, Typography } from "@mui/material";
import React from "react";

const CustomToggle = ({
  name,
  label,
  isChecked,
  handleOnChange,
  containerStyles,
}) => {
  const handleChange = (event) => {
    if (handleOnChange) {
      handleOnChange(name, event.target.checked);
    }
  };
  return (
    <Grid container spacing={2} alignItems="center" sx={{ ...containerStyles }}>
      <Grid item xs={10}>
        <Typography variant="body1" component="div">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Switch checked={isChecked} size="small" onChange={handleChange} />
      </Grid>
    </Grid>
  );
};

export default CustomToggle;
